var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.065,
    height: 45.777,
    viewBox: "0 0 48.065 45.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiple-devices-svgrepo-com",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M4,31.466V8.578A4.591,4.591,0,0,1,8.578,4H40.621A4.591,4.591,0,0,1,45.2,8.578V31.466a4.591,4.591,0,0,1-4.578,4.578H8.578A4.591,4.591,0,0,1,4,31.466Z",
    transform: "translate(0.289)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M40.188,7H8.144A1.081,1.081,0,0,0,7,8.144V31.033a1.081,1.081,0,0,0,1.144,1.144H40.188a1.081,1.081,0,0,0,1.144-1.144V8.144A1.081,1.081,0,0,0,40.188,7Z",
    transform: "translate(0.722 0.433)",
    fill: "#e3f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M43.2,33.578H6.578A4.591,4.591,0,0,1,2,29H47.777A4.591,4.591,0,0,1,43.2,33.578Z",
    transform: "translate(0 3.61)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M24,44.044V16.578A4.591,4.591,0,0,1,28.578,12H42.311a4.591,4.591,0,0,1,4.578,4.578V44.044a4.591,4.591,0,0,1-4.578,4.578H28.578A4.591,4.591,0,0,1,24,44.044Z",
    transform: "translate(3.177 1.155)",
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M41.877,15H28.144A1.081,1.081,0,0,0,27,16.144V41.322a1.081,1.081,0,0,0,1.144,1.144H41.877a1.081,1.081,0,0,0,1.144-1.144V16.144A1.081,1.081,0,0,0,41.877,15Z",
    transform: "translate(3.61 1.589)",
    fill: "#e3f8fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 1.717,
    cy: 1.717,
    r: 1.717,
    transform: "translate(36.905 45.199)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDevices);
export default __webpack_public_path__ + "static/media/myDevices.52ed4b1a2b611707bd3abc66d9ebd2c0.svg";
export { ForwardRef as ReactComponent };